import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Grid from 'material-ui/Grid'
import Dialog, { DialogTitle, DialogContent } from 'material-ui/Dialog'
import { I18n } from 'react-redux-i18n'

import { toggleLanguageDialog, setLocale } from 'modules/translations'
import parametersSelector from 'selectors/parameters'

const Languages = ({ config_parameters, toggleLanguageDialog, setLocale, open }) => (
  <Dialog open={open} onClose={() => toggleLanguageDialog()}>
    <DialogTitle>{I18n.t('header.choose_language')}</DialogTitle>
    <DialogContent>
      <Grid container>
        {config_parameters['locales'].map(locale => (
          <Grid item xs={3} key={locale}>
            <a
              href="/"
              onClick={e => e.preventDefault() || setLocale(locale) || toggleLanguageDialog()}
            >
              {I18n.t(`locale.${locale}`)}
            </a>
          </Grid>
        ))}
      </Grid>
    </DialogContent>
  </Dialog>
)

const mapStateToProps = state => ({
  open: state.translations.language_dialog_opened,
  config_parameters: parametersSelector(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ toggleLanguageDialog, setLocale }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Languages)



// WEBPACK FOOTER //
// ./src/containers/layouts/default/header/languages.js